import { FC, useMemo } from 'react';
import { Select, SelectProps } from '@app/form_components';
import { useDesign } from '@app/hooks';
import { Option } from '@app/types';

export type CsvDropdownProps = Omit<SelectProps<string>, 'options'>;

/** Select a @see DesignCsvData from a @see Design. */
export const CsvDropdown: FC<CsvDropdownProps> = (selectProps) => {
  const serialized = useDesign();

  const options = useMemo(() => {
    return serialized.csvData.map((csv): Option<string> => ({
      label: csv.name ?? '<Unnamed>',
      value: csv.id
    }));
  }, [serialized.csvData]);

  return (
    <Select
      noOptionsMessage={() => 'No CSVs in the design.'}
      placeholder="Select CSV from design."
      {...selectProps}
      options={options}
    />
  );
};
